import * as LDClient from 'launchdarkly-js-client-sdk';

class LaunchDarklyClient {
  static instance = null;

  constructor() {
    this.client = null;
    LaunchDarklyClient.instance = this;
  }

  async initialize(envKey, user) {
    if (this.client) {
      return this.client;
    }

    return new Promise((resolve, reject) => {
      this.client = LDClient.initialize(envKey, user);

      this.client.on('ready', () => {
        resolve(this.client);
      });

      this.client.on('failed', (err) => {
        console.error('failed to initialize:', err);
        reject(err);
      });
    });
  }

  getClient() {
    if (!this.client) {
      throw new Error('client not initialized');
    }
    return this.client;
  }

  async getFeatureFlag(flagKey, defaultValue = false) {
    if (!this.client) {
      throw new Error('client not initialized');
    }
    return this.client.variation(flagKey, defaultValue);
  }

  async close() {
    await this.client.close();
    this.client = null;
  }
}

export default new LaunchDarklyClient();
